import React from "react";
import { Box } from "app/components/common";
import normalize from "app/utils/normalize";
import Theme from "app/Theme/Theme";
import { IIconBoxProps } from "./type";
import LinearGradient from "react-native-linear-gradient";
import { isWebDesktop } from "@microdoing/shared/utils/deviceDetectors";

export const IconBox = ({
  width = normalize(40),
  height = normalize(40),
  backgroundColor = "neutral.white",
  borderRadius = 4,
  isActive,
  icon,
}: IIconBoxProps) => {
  return isWebDesktop ? (
    <Box
      alignItems="center"
      justifyContent="center"
      backgroundColor={backgroundColor}
      width={width}
      height={height}
      borderRadius={borderRadius}
      style={{
        background: isActive
          ? `linear-gradient(109.23deg, ${`${theme.colors["gradient.blueGradient.end"]} -101.65%, ${theme.colors["gradient.blueGradient.start"]} 104.04%)`}`
          : null,
      }}
    >
      {icon}
    </Box>
  ) : (
    <LinearGradient
      alignItems="center"
      justifyContent="center"
      pointerEvents="none"
      width={width}
      height={height}
      style={{
        borderRadius,
      }}
      start={{ x: -1, y: 1 }}
      end={{ x: 2, y: 0 }}
      colors={
        isActive
          ? [
              Theme.colors["gradient.blueGradient.start"],
              Theme.colors["gradient.blueGradient.end"],
            ]
          : [Theme.colors["brand.50"], Theme.colors["brand.50"]]
      }
    >
      {icon}
    </LinearGradient>
  );
};
